import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ShopProvider } from './contexts/ShopContext';
import { FavoritesProvider } from './contexts/FavoritesContext';
import Header from './components/Header';
import ProtectedRoute from './components/ProtectedRoute';
import VersionInfo, { logVersionInfo } from './components/VersionInfo';
import Login from './pages/Login';
import SignUpPage from './pages/SignUpPage';
import Dashboard from './pages/Dashboard';
import JoinPage from './pages/JoinPage';
import TermsPage from './pages/TermsPage';
import BetaAccessTerms from './pages/BetaAccessTerms';
import AcceptTermsPage from './pages/AcceptTermsPage';
import PrivacyPolicy from './pages/PrivacyPolicy';
import ProfilePage from './pages/ProfilePage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import AuthActionPage from './pages/AuthActionPage';
import './styles/design-system.css';
import './styles/header.css';
import './App.css';

function App() {
  // Log version info to console for developers
  React.useEffect(() => {
    logVersionInfo();
  }, []);

  return (
    <AuthProvider>
      <ShopProvider>
        <FavoritesProvider>
        <Router>
          <div className="App">
            <Header />
            <main className="main-content">
              <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/signup" element={<SignUpPage />} />
                <Route path="/join/:token" element={<JoinPage />} />
                <Route path="/terms" element={<TermsPage />} />
                <Route path="/terms/:version" element={<TermsPage />} />
                <Route path="/beta-terms" element={<BetaAccessTerms />} />
                <Route path="/accept-terms" element={<AcceptTermsPage />} />
                <Route path="/privacy" element={<PrivacyPolicy />} />
                <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                <Route path="/auth/action" element={<AuthActionPage />} />
                <Route
                  path="/profile"
                  element={
                    <ProtectedRoute>
                      <ProfilePage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/"
                  element={
                    <ProtectedRoute>
                      <Dashboard />
                    </ProtectedRoute>
                  }
                />
              </Routes>
            </main>
            <footer className="app-footer">
              <div className="footer-legal">
                <Link to="/terms">Terms of Service</Link>
                <span className="footer-separator">|</span>
                <Link to="/privacy">Privacy Policy</Link>
              </div>
              <VersionInfo mode="simple" className="footer-version" />
            </footer>
          </div>
        </Router>
        </FavoritesProvider>
      </ShopProvider>
    </AuthProvider>
  );
}

export default App;